// [APP-FORK] 안드로이드 intent:// URL 의 `package=` 값 — 현재 접속 도메인의 환경(dev/qa/prod)에
//  맞는 flavor 패키지를 고른다. QR 랜딩(AppLinkLanding)과 claim 인앱가드(AppOnlyGuard)가 공용
//  (스토어 URL 을 storeUrls.ts 로 모은 것과 같은 이유 — 값이 갈리면 안 되는 곳이 2군데다).
//
// ★왜 필요한가: intent URL 에 `package=` 가 있으면 안드로이드는 App Link 검증 결과·host 와
//   무관하게 그 패키지를 직접 실행한다. prod 패키지로 하드코딩돼 있던 동안은
//   shopuser-dev / shopuser-qa 도메인에서 "앱에서 열기" 를 눌러도 prod 앱이 열렸다
//   (dev/qa 앱이 설치돼 있어도 무시됐다).
//
// ★패키지·suffix 근거: naegift_mobile_app/android/app/build.gradle.kts
//   :46 applicationId "com.naegift.app" / :78 dev applicationIdSuffix ".dev" / :86 qa ".qa"
//
// ★user/admin 이 같은 패키지인 이유: 모바일 앱은 하나뿐이고 동일 MainActivity 가 shopuser·
//   shopadmin 두 host 를 다 받는다(naegift_mobile_app/.../AndroidManifest.xml:54, :66).
//   admin-app 쪽 랜딩(naegift-admin-app/src/app/AppLinkLanding.js)도 같은 규칙을 쓴다.

const BASE_PACKAGE = 'com.naegift.app';

// 환경 판정은 서브도메인(첫 라벨)의 끝으로 본다 — 실제 도메인이 shopuser-dev / shopadmin-dev,
//  shopuser-qa / shopadmin-qa, shopuser / shopadmin 6종이다(각 앱 .github/workflows/cd-*.yml).
//  ★hostname 을 쓰는 이유: host 는 포트를 포함해 판정이 흔들린다.
//  ★단순 includes('-dev') 가 아닌 이유: 상위 도메인이나 다른 라벨에 '-dev' 가 섞여도 오판하지 않는다.
//  localhost 등 매칭 없는 호스트는 기본(prod) — 하드코딩 시절과 동일 동작.
export const androidAppPackage = (): string => {
  const hostname =
    typeof window !== 'undefined' ? window.location.hostname || '' : '';
  const subdomain = hostname.split('.')[0];
  if (subdomain.endsWith('-dev')) return `${BASE_PACKAGE}.dev`;
  if (subdomain.endsWith('-qa')) return `${BASE_PACKAGE}.qa`;
  return BASE_PACKAGE;
};

// [APP-FORK] iOS 커스텀 스킴(naegift://) 도 환경별로 갈라야 한다 — androidAppPackage() 와 같은 이유,
//  다른 메커니즘. Android 는 intent:// 의 package= 로 정확한 앱을 지정할 수 있지만, iOS 커스텀
//  스킴엔 그런 필드가 없어 "스킴 문자열 자체"가 유일한 식별자다. dev/qa/prod 앱 3개가 전부
//  'naegift'를 등록하고 있으면 iOS 가 그중 하나(임의)만 열고, 나머지 두 환경은 절대 못 연다
//  (실제로 dev/qa 링크 모두 qa 앱으로만 열리는 게 관측됨).
//  ★스킴 값 근거: naegift_mobile_app/ios/Flutter/Flavors/{Dev,Qa,Prod}.xcconfig 의
//    APP_URL_SCHEME, lib/config.dart AppConfig.urlScheme 과 반드시 동일해야 한다(3곳 일치 필수).
export const iosAppScheme = (): string => {
  const hostname =
    typeof window !== 'undefined' ? window.location.hostname || '' : '';
  const subdomain = hostname.split('.')[0];
  if (subdomain.endsWith('-dev')) return 'naegift-dev';
  if (subdomain.endsWith('-qa')) return 'naegift-qa';
  return 'naegift';
};
